import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { SelectItem } from 'types/formElement';
import Select, { SingleValue } from 'react-select';
import { select } from '@theme/components/select';
import { Control, Controller, FieldError, FieldErrorsImpl, FieldValues, Merge, UseFormWatch } from 'react-hook-form';

interface Props {
    id: string;
    valueComponent: string | number;
    label: string;
    options: SelectItem[];
    control: Control<FieldValues>;
    onChangeComponent: (value: string | number) => void;
    isRequired?: boolean;
    isInvalid?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | null;
    flex?: number;
    isCompact?: boolean;
    watch?: UseFormWatch<FieldValues>;
}

const SelectComponent: FC<Props> = ({
    id,
    valueComponent,
    label,
    options,
    onChangeComponent,
    control,
    isRequired = false,
    isInvalid = null,
    flex = 1,
    isCompact = false,
    watch,
}) => {
    const [error, setError] = useState('');

    useEffect(() => {
        if (isInvalid?.message) {
            setError(isInvalid?.message as string);
        } else {
            setError('');
        }
    }, [isInvalid]);

    const handleOnChange = useCallback(
        (option: SingleValue<SelectItem | null>) => {
            if (option) {
                onChangeComponent(option.id);
            }
        },
        [onChangeComponent],
    );

    const valueOption = useMemo(() => {
        const valueFound = options.find((option) => option.id === valueComponent);
        if (valueFound) {
            return valueFound;
        }
        return null;
    }, [options, valueComponent]);

    return (
        <FormControl
            flex={flex}
            variant="floating"
            id={id}
            paddingBottom={isCompact ? '0' : '20px'}
            isRequired={isRequired}
            isInvalid={isInvalid !== null}
        >
            <Controller
                name={id}
                control={control}
                rules={{ required: isRequired ? 'Questo campo è obbligatorio' : false }}
                defaultValue={valueOption}
                render={({ field: { onChange, onBlur, value } }) => {
                    const valueSet = options.find((option) => option.id === valueComponent) ? value : null;
                    return (
                        <Select
                            styles={select(isCompact, isInvalid ? true : false)}
                            onBlur={onBlur}
                            placeholder={`${label}${isRequired ? ' *' : ''}`}
                            defaultValue={valueOption}
                            value={watch && watch(id, valueSet)}
                            /* value={value} */
                            options={options}
                            onChange={(option: SelectItem | null) => {
                                onChange(option);
                                handleOnChange(option);
                            }}
                            className={`selectComponent ${isInvalid ? 'not-valid' : ''}`}
                            // required={isRequired}
                        />
                    );
                }}
            />
            {valueComponent ? (
                <FormLabel>
                    {label}
                    {isRequired && ' *'}
                </FormLabel>
            ) : null}
            <FormErrorMessage position="absolute" fontSize={12}>
                {error}
            </FormErrorMessage>
        </FormControl>
    );
};

export default SelectComponent;
